import { LOAD_BALANCE, LOAD_BALANCE_FAIL, LOAD_BALANCE_SUCCESS } from 'redux/Reducers/Balance/BalanceReducer';
import Store from 'redux/store';

import { cloudloyalty } from '../clients';

export const FetchBalance = async (User, finallyCallback = () => {}) => {
  Store.dispatch({ type: LOAD_BALANCE });
  cloudloyalty(User).get('/v1/participants/me/simpleBalance').then((response) => {
    Store.dispatch({
      type: LOAD_BALANCE_SUCCESS,
      payload: {
        ...response,
      },
    });
  }).catch((e) => {
    Store.dispatch({
      type: LOAD_BALANCE_FAIL,
      error: e,
    });
  })
    .finally(() => {
      finallyCallback();
    });
};

export const FetchBalanceCached = () => {};
